import { servicesQuery } from '@/services/api';
import { useAuth } from '@/services/auth';

export function useCopilotHistory() {
  const auth = useAuth();

  return servicesQuery.getCopilotSessions.useInfiniteQuery({
    queryKey: ['copilotHistory'],
    initialPageParam: 1,
    queryData: ({ pageParam }) => ({
      params: { accountId: auth.account.id },
      query: { page: pageParam },
    }),
    getNextPageParam: (lastPage) => {
      const { pagination } = lastPage.body.meta;
      const totalPages = Math.ceil(pagination.total / pagination.size);
      return pagination.page < totalPages ? pagination.page + 1 : undefined;
    },
  });
}
